import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import logo from './vijaya logo.png';
import small_logo from './vdc_logo.png';
import { BASE_URL } from "./Constants.js";
import useAuth from './useAuth';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
const Sidebar = ({ isOpen: propIsOpen }) => {
  useAuth();
  const [hovered, setHovered] = useState(false);
  const [users, setUsers] = useState([]);
  const [error, setError] = useState(null);
  const [checkboxStates, setCheckboxStates] = useState({});
  const [loading, setLoading] = useState(true);
  const [openDropdowns, setOpenDropdowns] = useState({});

  const isOpen = hovered || propIsOpen; // Expanded on hover or permanently open

  const toggleDropdown = (id) => {
    setOpenDropdowns((prevState) => ({
      ...prevState,
      [id]: !prevState[id],
    }));
  };

  useEffect(() => {
    const fetchEmpList = async () => {
      const token = localStorage.getItem('authToken');

      if (!token) {
        setError('No token found!');
        setLoading(false);
        return;
      }

      try {
        const response = await fetch(`${BASE_URL}emp_list_code`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        });

        const data = await response.json();
        if (data.status && Array.isArray(data.data)) {
          setUsers(data.data);

          const user = data.data[0]; // assuming only one user is returned

          setCheckboxStates({
            admin_role: user.admin_role === 'Y',
            super_admin_role: user.super_admin_role === 'Y',
            employee_role: user.employee_role === 'Y',
            branch_manager_role: user.branch_manager_role === 'Y',
            candidate_role: user.candidate_role === 'Y',
          });
          //  setCheckboxStates(checkboxMap);

        } else {
          setError('Invalid response format');
        }
      } catch (err) {
        setError('Failed to fetch employee list');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchEmpList();
  }, []);

  const downloadReport = async () => {
    const confirmed = window.confirm('Are you sure you want to download the report?');
    if (!confirmed) return;

    try {
      const response = await fetch('https://uniform.vdcapp.in/backend/api/all_areas_stock_report', {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('authToken')}`,  // Add token if required
          'Content-Type': 'application/json',
        }
      });
      if (!response.ok) throw new Error('Failed to fetch report');

      const result = await response.json();

      if (!result.status || !result.data || result.data.length === 0) {
        alert('No data to download');
        return;
      }

      // Use the 'data' array for Excel conversion
      const worksheet = XLSX.utils.json_to_sheet(result.data);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'StockReport');

      const wbout = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

      const blob = new Blob([wbout], { type: 'application/octet-stream' });
      saveAs(blob, 'AllAreaStockReport.xlsx');

    } catch (error) {
      alert('Error downloading report: ' + error.message);
    }
  };

  const downloadReportemployeePaid = async () => {
    const confirmed = window.confirm('Are you sure you want to download the report?');
    if (!confirmed) return;

    try {
      const response = await fetch('https://uniform.vdcapp.in/backend/api/employee_paid_report', {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('authToken')}`,  // Add token if required
          'Content-Type': 'application/json',
        }
      });
      if (!response.ok) throw new Error('Failed to fetch report');

      const result = await response.json();

      if (!result.status || !result.data || result.data.length === 0) {
        alert('No data to download');
        return;
      }

      // Use the 'data' array for Excel conversion
      const worksheet = XLSX.utils.json_to_sheet(result.data);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'StockReport');

      const wbout = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

      const blob = new Blob([wbout], { type: 'application/octet-stream' });
      saveAs(blob, 'downloadReportemployeePaid.xlsx');

    } catch (error) {
      alert('Error downloading report: ' + error.message);
    }
  };

  const downloadReportStockOut = async () => {
    const confirmed = window.confirm('Are you sure you want to download the report?');
    if (!confirmed) return;

    try {
      const response = await fetch('https://uniform.vdcapp.in/backend/api/stock_out_report', {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('authToken')}`,  // Add token if required
          'Content-Type': 'application/json',
        }
      });
      if (!response.ok) throw new Error('Failed to fetch report');

      const result = await response.json();

      if (!result.status || !result.data || result.data.length === 0) {
        alert('No data to download');
        return;
      }

      // Use the 'data' array for Excel conversion
      const worksheet = XLSX.utils.json_to_sheet(result.data);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'StockReport');

      const wbout = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

      const blob = new Blob([wbout], { type: 'application/octet-stream' });
      saveAs(blob, 'downloadReportStockOut.xlsx');

    } catch (error) {
      alert('Error downloading report: ' + error.message);
    }
  };

  return (
    <aside
      className={`menu-sidebar d-none d-lg-block bg-white`}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        width: isOpen ? '300px' : '100px',
        overflow: 'hidden',
        transition: 'width 0.3s ease',
        position: 'fixed',
        height: '100vh',
        top: 0,
        left: 0,
        zIndex: 1030,
      }}
    >
      <div className="logo d-flex align-items-center justify-content-center p-3">
        <a href="#">
          <img
            src={isOpen ? logo : small_logo}
            alt="Logo"
            style={{
              height: isOpen ? '50px' : '40px',
              width: 'auto',
              transition: 'all 0.3s ease',
            }}
          />
        </a>
      </div>

      <div className="menu-sidebar__content">
        <nav className="navbar-sidebar">
          <ul className="list-unstyled navbar__list">
            <li>
              <Link to="/dashboard" className="d-flex align-items-center">
                <i className="fas fa-tachometer-alt me-2" style={{ minWidth: '20px' }}></i>
                {isOpen && <span className="ms-2">Dashboard</span>}
              </Link>
            </li>

            {/* Candidates - Visible if candidate_role or super_admin */}
            {(checkboxStates.employee_role || checkboxStates.candidate_role || checkboxStates.super_admin_role || checkboxStates.admin_role) && (
              <li>
                <Link to="/manage_employee" className="d-flex align-items-center">
                  <i className="fas fa-users me-2" style={{ minWidth: '20px' }}></i>
                  {isOpen && <span className="ms-2">Issue Uniforms</span>}
                </Link>
              </li>
            )}

            {/* Reports - Optional: only for super_admin or both roles */}

            {(checkboxStates.super_admin_role || checkboxStates.branch_manager_role) && (
              <li>
                <Link to="/manage_indent" className="d-flex align-items-center">
                  <i className="fas fa-chart-bar me-2" style={{ minWidth: '20px' }}></i>
                  {isOpen && <span className="ms-2">Indent</span>}
                </Link>
              </li>
            )}
            {/* Users - Show only to super admin */}
            {checkboxStates.super_admin_role && (
              <li>
                <Link to="/emp_list" className="d-flex align-items-center">
                  <i className="fas fa-chart-bar me-2" style={{ minWidth: '20px' }}></i>
                  {isOpen && <span className="ms-2">Users</span>}
                </Link>
              </li>
            )}

            {/* Employee - if employee_role or super_admin */}
            {/* {(checkboxStates.employee_role || checkboxStates.super_admin_role) && (
              <li>
                <Link to="/manage_employee" className="d-flex align-items-center">
                  <i className="fas fa-users me-2" style={{ minWidth: '20px' }}></i>
                  {isOpen && <span className="ms-2">Employee</span>}
                </Link>
              </li>
            )} */}

            {/* Settings - Only for super_admin */}

            {(checkboxStates.super_admin_role || checkboxStates.admin_role) && (<li>
              <Link to="/manage_stocks" className="d-flex align-items-center">
                <i className="fas fa-chart-bar me-2" style={{ minWidth: '20px' }}></i>
                {isOpen && <span className="ms-2">Stock Details</span>}
              </Link>
            </li>)}

            <li className="has-sub">
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  toggleDropdown('settings');
                }}
                className="d-flex align-items-center justify-content-between"
              >
                <div className="d-flex align-items-center">
                  <i className="fas fa-cog me-2" style={{ minWidth: '20px' }}></i>
                  {isOpen && <span>Settings</span>}
                </div>
                {isOpen && (
                  <i className={`fas fa-angle-${openDropdowns['settings'] ? 'down' : 'left'}`}></i>
                )}
              </a>

              {isOpen && openDropdowns['settings'] && (
                <ul className="list-unstyled ms-4 mt-2">
                  {checkboxStates.super_admin_role && (<li><Link to="/manage_dresstype"><i className="fas fa-angle-right me-2"></i><span>Dress Type</span></Link></li>)}
                  {checkboxStates.super_admin_role && (<li><Link to="/manage_dresssize"><i className="fas fa-angle-right me-2"></i><span>Dress Size</span></Link></li>)}
                  {checkboxStates.super_admin_role && (<li><Link to="/manage_dresscolor"><i className="fas fa-angle-right me-2"></i><span>Dress Colour</span></Link></li>)}
                  {checkboxStates.super_admin_role && (<li><Link to="/manage_mapping"><i className="fas fa-angle-right me-2"></i><span>Mapping</span></Link></li>)}

                  {checkboxStates.super_admin_role && (<li><Link to="/manage_areas"><i className="fas fa-angle-right me-2"></i><span>Areas</span></Link></li>)}
                </ul>
              )}
            </li>

            <li className="has-sub">
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  toggleDropdown('reports');
                }}
                className="d-flex align-items-center justify-content-between"
              >
                <div className="d-flex align-items-center">
                  <i className="fas fa-cog me-2" style={{ minWidth: '20px' }}></i>
                  {isOpen && <span>Reports</span>}
                </div>
                {isOpen && (
                  <i className={`fas fa-angle-${openDropdowns['reports'] ? 'down' : 'left'}`}></i>
                )}
              </a>

              {isOpen && openDropdowns['reports'] && (
                <ul className="list-unstyled ms-4 mt-2">
                  {(<li>
                    <a
                      href="#"
                      className="d-flex align-items-center"
                      onClick={e => {
                        e.preventDefault();
                        downloadReport();
                      }}
                    >
                      <i className="fas fa-dollar-sign" style={{ minWidth: '20px' }}></i>
                      {isOpen && <span className="ms-2">All Area GRN Report</span>}
                    </a>
                  </li>)}

                  {(<li>
                    <a
                      href="#"
                      className="d-flex align-items-center"
                      onClick={e => {
                        e.preventDefault();
                        downloadReportemployeePaid();
                      }}
                    >
                      <i className="fas fa-dollar-sign" style={{ minWidth: '20px' }}></i>
                      {isOpen && <span className="ms-2">Employee Purchased Report</span>}
                    </a>
                  </li>
                  )}

                  {(<li>
                    <a
                      href="#"
                      className="d-flex align-items-center"
                      onClick={e => {
                        e.preventDefault();
                        downloadReportStockOut();
                      }}
                    >
                      <i className="fas fa-dollar-sign" style={{ minWidth: '20px' }}></i>
                      {isOpen && <span className="ms-2">Stock Delivery Report</span>}
                    </a>
                  </li>
                  )}
                  {(<li><Link to="/manage_stock_reports"><i className="fas fa-angle-right me-2"></i><span>Stock Reports</span></Link></li>)}
                  {(<li><Link to="/focus_report"><i className="fas fa-angle-right me-2"></i><span>Focus Reports</span></Link></li>)}
                  {(<li><Link to="/indent_reports"><i className="fas fa-angle-right me-2"></i><span>Indent Reports</span></Link></li>)}
                  {(<li><Link to="/pending_indent_reports"><i className="fas fa-angle-right me-2"></i><span>Pending Indent Reports</span></Link></li>)}
                  {(<li><Link to="/overall_stock_reports"><i className="fas fa-angle-right me-2"></i><span>Over All Stock Balance Report</span></Link></li>)}
                  {(<li><Link to="/opening_stock_report"><i className="fas fa-angle-right me-2"></i><span>Opening Stock Report</span></Link></li>)}
                  {(<li><Link to="/area_wise_shirt_trouser"><i className="fas fa-angle-right me-2"></i><span>Date Wise Consumed Report</span></Link></li>)}

                  <li>
                    <Link to="/manage_candidate_reports" className="d-flex align-items-center">
                      <i className="fas fa-chart-bar me-2" style={{ minWidth: '20px' }}></i>
                      {isOpen && <span className="ms-2">Employee Reports</span>}
                    </Link>
                  </li>
                  <li>
                    <Link to="/area_wise_payment_report" className="d-flex align-items-center">
                      <i className="fas fa-dollar-sign" style={{ minWidth: '20px' }}></i>
                      {isOpen && <span className="ms-2">Area Wise Payment</span>}
                    </Link>
                  </li>
                </ul>
              )}
            </li>





            {/* {(checkboxStates.super_admin_role || checkboxStates.employee_role || checkboxStates.candidate_role) && (
              <li>
                <Link to="/manage_stock_reports" className="d-flex align-items-center">
                  <i className="fas fa-chart-bar me-2" style={{ minWidth: '20px' }}></i>
                  {isOpen && <span className="ms-2">Stock Reports</span>}
                </Link>
              </li>
            )} */}
            <li>
              {checkboxStates.super_admin_role && (<Link to="/manage_backend" className="d-flex align-items-center">
                <i className="fas fa-dollar-sign" style={{ minWidth: '20px' }}></i>
                {isOpen && <span className="ms-2">Backend Payment Update</span>}
              </Link>)}
            </li>

            {/* <li>
            <Link to="/area_wise_payment_report" className="d-flex align-items-center">
                <i className="fas fa-dollar-sign" style={{ minWidth: '20px' }}></i>
                {isOpen && <span className="ms-2">Area Wise Payment</span>}
              </Link>
            </li> */}

            {/* <li>
            <Link to="/area_wise_shirt_trouser" className="d-flex align-items-center">
                <i className="fas fa-dollar-sign" style={{ minWidth: '20px' }}></i>
                {isOpen && <span className="ms-2">Date Wise Consumed Report</span>}
              </Link>
            </li> */}
            {/* <li>
            <Link to="/focus_report" className="d-flex align-items-center">
                <i className="fas fa-dollar-sign" style={{ minWidth: '20px' }}></i>
                {isOpen && <span className="ms-2">Focus Report</span>}
              </Link>
            </li> */}
            {/* {(checkboxStates.admin_role) && (
              <>
            <li>
            <a
            href="#"
            className="d-flex align-items-center"
            onClick={e => {
              e.preventDefault();
              downloadReport();
            }}
          >
            <i className="fas fa-dollar-sign" style={{ minWidth: '20px' }}></i>
            {isOpen && <span className="ms-2">All Area Stock Report</span>}
          </a>
            </li>
          <li>
            <a
            href="#"
            className="d-flex align-items-center"
            onClick={e => {
              e.preventDefault();
              downloadReportemployeePaid();
            }}
          >
            <i className="fas fa-dollar-sign" style={{ minWidth: '20px' }}></i>
            {isOpen && <span className="ms-2">Employee Paid Report</span>}
          </a>
            </li>
          <li>
            <a
            href="#"
            className="d-flex align-items-center"
            onClick={e => {
              e.preventDefault();
              downloadReportStockOut();
            }}
          >
            <i className="fas fa-dollar-sign" style={{ minWidth: '20px' }}></i>
            {isOpen && <span className="ms-2">Stock Out Report</span>}
          </a>
            </li></>)} */}

          </ul>
        </nav>
      </div>
    </aside>
  );
};

export default Sidebar;
